// panelVisibilitySlice.js
//
// Sürekli açık panellerin (Kolon Şeması / Pano Detay / Başlık / Kablo Bacası)
// görünürlüğü — PAFTA BAZINDA. Her paftanın kendi panel-görünürlük durumu var;
// pafta değişince o paftaya ait paneller açılır, diğerleri gizlenir.
// (Paneller mount kalır, CSS ile gizlenir → sahne içeriği korunur; UI toggle olur.)

import { createSlice } from '@reduxjs/toolkit';

export const PANEL_KEYS = ['kolonSema', 'panoDetay', 'baslik', 'kabloBacasi'];

// Bir paftada hangi paneller KULLANILABİLİR (toggle butonu gösterilir).
// Bilinmeyen pafta → hepsi (geriye dönük uyum). Şantiye tip proje → yalnız başlık.
const PAFTA_PANELS = {
  santiye: ['baslik'],
  construction_site: ['baslik'],
  mimari: [],
  architectural: [],
};
export function panelsForTab(tabId) {
  return PAFTA_PANELS[tabId] || PANEL_KEYS;
}

const emptyVis = () => ({ kolonSema: false, panoDetay: false, baslik: false, kabloBacasi: false });
// SABİT (frozen) fallback — selector'da kullanılır. emptyVis() her çağrıda YENİ
// obje döndürdüğü için selector'da kullanılırsa useSyncExternalStore sonsuz
// re-render'a ("Maximum update depth") girer. Selector daima aynı referansı döndürmeli.
const EMPTY_VIS = Object.freeze({ kolonSema: false, panoDetay: false, baslik: false, kabloBacasi: false });

const initialState = {
  byTab: {}, // { [tabId]: { kolonSema, panoDetay, baslik, kabloBacasi } }
};

const panelVisibilitySlice = createSlice({
  name: 'panelVisibility',
  initialState,
  reducers: {
    togglePanel(state, action) {
      const { tabId, panel } = action.payload || {};
      if (!tabId || !panel) return;
      if (!state.byTab[tabId]) state.byTab[tabId] = emptyVis();
      if (panel in state.byTab[tabId]) state.byTab[tabId][panel] = !state.byTab[tabId][panel];
    },
    setPanelVisible(state, action) {
      const { tabId, panel, visible } = action.payload || {};
      if (!tabId || !panel) return;
      if (!state.byTab[tabId]) state.byTab[tabId] = emptyVis();
      if (panel in state.byTab[tabId]) state.byTab[tabId][panel] = !!visible;
    },
    hideAllPanels(state, action) {
      const tabId = action.payload?.tabId;
      if (tabId) {
        if (state.byTab[tabId]) Object.keys(state.byTab[tabId]).forEach((k) => { state.byTab[tabId][k] = false; });
      } else {
        state.byTab = {};
      }
    },
  },
});

export const { togglePanel, setPanelVisible, hideAllPanels } = panelVisibilitySlice.actions;

// Aktif paftanın panel görünürlüğü. tabId verilmezse veya kaydı yoksa SABİT
// EMPTY_VIS döner (yeni obje DEĞİL) → useSelector stabil kalır, sonsuz re-render olmaz.
export const selectPanelVisibilityForTab = (state, tabId) =>
  (tabId && state.panelVisibility.byTab[tabId]) || EMPTY_VIS;

export default panelVisibilitySlice.reducer;
